import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useMeetingContext } from "../../../../../context/MeetingContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";
import { FaTimes, FaChevronLeft } from "react-icons/fa";
import CallToAction from "./CallToAction";
import MediaFile from "./MediaFile";
import WebsiteInput from "./WebsiteView/WebsiteInput";
import DocumentFile from "./DocumentFile";
import Prompter from "./Prompter";

function CreateElement() {
  const { folderId } = useParams();
  const navigate = useNavigate();

  const {
    selectedCreateElement,
    setSelectedCreateElement,
    onClosePanel,
    setCtaUpdateData,
    updatePresetId,
    setName,
    setMediaFileName,
    setSelectedFolder,
    step,
    setStep,
  } = useMeetingContext();

  const { selectedTemplateKey, setSelectedTemplateKey } = useEditCtaContext();

  useEffect(() => {
    if (!updatePresetId) {
      setSelectedFolder("");
      setName("");
      setMediaFileName("");
      setSelectedCreateElement("");
    }
  }, [folderId]);

  const handleBack = () => {
    if (selectedTemplateKey) {
      setSelectedTemplateKey("");
    } else if (folderId) {
      navigate(`/dashboard/folders/element/${folderId}`, { replace: false });
    } else {
      navigate(`/dashboard/folders`, { replace: false });
    }
  };

  return (
    <div className="primary-card-background rounded-2xl overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-3 md:px-4 lg:px-6 py-2.5 md:py-3 lg:py-4">
        <div className="flex items-center gap-2 md:gap-4 flex-1 min-w-0">
          <button
            onClick={handleBack}
            className="text-white hover:text-gray-300 transition-colors p-1 flex-shrink-0"
          >
            <FaChevronLeft className="w-4 h-4 md:w-5 md:h-5" />
          </button>
          <div className="flex items-center gap-2 md:gap-3 flex-1 min-w-0">
            <svg
              width="24"
              height="24"
              className="hidden md:block flex-shrink-0"
              viewBox="0 0 31 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29.6816 28.7352V21.9552C29.6816 21.5851 29.3817 21.2852 29.0116 21.2852H11.9516C11.5816 21.2852 11.2816 21.5851 11.2816 21.9552V28.7352C11.2816 29.1052 11.5816 29.4052 11.9516 29.4052H29.0116C29.3817 29.4052 29.6816 29.1052 29.6816 28.7352Z"
                stroke="white"
                strokeWidth="1.36"
                strokeMiterlimit="10"
              />
              <path
                d="M9.11133 28.7351L9.11133 1.37509C9.11133 1.00506 8.81136 0.705078 8.44133 0.705078L1.67133 0.705078C1.30129 0.705078 1.00133 1.00506 1.00133 1.37509L1.00133 28.7351C1.00133 29.1051 1.30129 29.4051 1.67133 29.4051H8.44133C8.81136 29.4051 9.11133 29.1051 9.11133 28.7351Z"
                stroke="white"
                strokeWidth="1.36"
                strokeMiterlimit="10"
              />
              <path
                d="M29.6816 8.15509V1.37509C29.6816 1.00506 29.3817 0.705078 29.0116 0.705078L11.9516 0.705078C11.5816 0.705078 11.2816 1.00506 11.2816 1.37509V8.15509C11.2816 8.52512 11.5816 8.8251 11.9516 8.8251L29.0116 8.8251C29.3817 8.8251 29.6816 8.52512 29.6816 8.15509Z"
                stroke="white"
                strokeWidth="1.36"
                strokeMiterlimit="10"
              />
              <path
                d="M19.4004 18.4451V11.6651C19.4004 11.2951 19.1004 10.9951 18.7304 10.9951H11.9604C11.5904 10.9951 11.2904 11.2951 11.2904 11.6651V18.4451C11.2904 18.8151 11.5904 19.1151 11.9604 19.1151H18.7304C19.1004 19.1151 19.4004 18.8151 19.4004 18.4451Z"
                stroke="white"
                strokeWidth="1.36"
                strokeMiterlimit="10"
              />
            </svg>
            <h1 className="text-white text-sm md:text-lg lg:text-2xl font-medium uppercase truncate">
              {selectedTemplateKey
                ? "Preview of Template"
                : "CREATE YOUR ELEMENT"}
            </h1>
          </div>
        </div>
      </div>

      <div
        className={`p-3 md:p-5 ${
          selectedTemplateKey === "" && selectedCreateElement !== "prompter"
            ? "flex flex-col lg:flex-row"
            : ""
        } h-[calc(100vh-100px-60px)] md:h-[calc(100vh-100px-80px)] overflow-y-auto md:overflow-hidden`}
      >
        {/* Left Sidebar */}
        {selectedTemplateKey === "" && selectedCreateElement !== "prompter" && (
          <div className="w-full lg:w-64 bg-black border-b lg:border-b-0 lg:border-r border-gray-800 flex lg:flex-col flex-row overflow-x-auto">
            <div className="p-2 lg:p-4 flex lg:flex-col flex-row gap-1 lg:space-y-1 flex-1 min-w-0">
              <button
                role="button"
                onClick={() => {
                  setSelectedCreateElement("cta");
                }}
                className={`px-3 lg:px-4 py-2 lg:py-3 text-base font-medium transition-colors cursor-pointer whitespace-nowrap text-start ${
                  selectedCreateElement === "cta"
                    ? "bg-[#360083] text-white"
                    : "text-gray-400 hover:text-white hover:bg-gray-900"
                }`}
              >
                Banner
              </button>
              <button
                role="button"
                onClick={() => {
                  setSelectedCreateElement("website");
                }}
                className={`px-3 lg:px-4 py-2 lg:py-3 text-base font-medium transition-colors cursor-pointer whitespace-nowrap text-start ${
                  selectedCreateElement === "website"
                    ? "bg-[#360083] text-white"
                    : "text-gray-400 hover:text-white hover:bg-gray-900"
                }`}
              >
                Webs
              </button>
              <button
                role="button"
                onClick={() => {
                  setSelectedCreateElement("media_file");
                }}
                className={`px-3 lg:px-4 py-2 lg:py-3 text-base font-medium transition-colors cursor-pointer whitespace-nowrap text-start ${
                  selectedCreateElement === "media_file"
                    ? "bg-[#360083] text-white"
                    : "text-gray-400 hover:text-white hover:bg-gray-900"
                }`}
              >
                Videos
              </button>
              <button
                role="button"
                onClick={() => {
                  setSelectedCreateElement("document_file");
                }}
                className={`px-3 lg:px-4 py-2 lg:py-3 text-base font-medium transition-colors cursor-pointer whitespace-nowrap text-start ${
                  selectedCreateElement === "document_file"
                    ? "bg-[#360083] text-white"
                    : "text-gray-400 hover:text-white hover:bg-gray-900"
                }`}
              >
                Slides
              </button>
              <button
                role="button"
                onClick={() => {
                  setSelectedCreateElement("prompter");
                }}
                className={`px-3 lg:px-4 py-2 lg:py-3 text-base font-medium transition-colors cursor-pointer whitespace-nowrap text-start ${
                  selectedCreateElement === "prompter"
                    ? "bg-[#360083] text-white"
                    : "text-gray-400 hover:text-white hover:bg-gray-900"
                }`}
              >
                Prompter
              </button>
            </div>
          </div>
        )}

        {/* Main Content Area */}
        <div
          className={`${
            selectedTemplateKey === "" && selectedCreateElement !== "prompter"
              ? "flex-1 overflow-auto"
              : "w-full min-h-full md:h-full"
          }`}
        >
          {selectedCreateElement === "" && (
            <div className="flex flex-col items-center justify-center h-full text-gray-400 p-6">
              <p className="text-base md:text-lg text-center">
                Select an element type to get started
              </p>
            </div>
          )}

          {selectedCreateElement === "cta" && <CallToAction />}
          {selectedCreateElement === "media_file" && <MediaFile />}
          {selectedCreateElement === "website" && <WebsiteInput />}
          {selectedCreateElement === "document_file" && <DocumentFile />}
          {selectedCreateElement === "prompter" && <Prompter />}
        </div>
      </div>

      {selectedCreateElement !== "" && (
        <button
          role="button"
          onClick={() => {
            onClosePanel();
            setCtaUpdateData(null);
            setSelectedCreateElement("");
          }}
          className="absolute top-4 right-4 text-white hover:text-gray-300 cursor-pointer"
        >
          <div className="rounded-full p-1 bg-gray-300 text-black hover:bg-gray-400">
            <FaTimes size={20} />
          </div>
        </button>
      )}
    </div>
  );
}

export default CreateElement;
